(() => {
  const roots = document.querySelectorAll('[data-mc-sealer-root]');

  roots.forEach((root) => {
    const form = root.querySelector('[data-mc-product-form]');
    if (!form) return;

    const variantInput = form.querySelector('[data-mc-variant-input]');
    const quantityInput = form.querySelector('[data-mc-quantity-input]');
    const offers = [...form.querySelectorAll('[data-mc-offer]')];
    const priceElement = form.querySelector('[data-mc-price]');
    const compareElement = form.querySelector('[data-mc-compare]');
    const savingsElement = form.querySelector('[data-mc-savings]');
    const unitElement = form.querySelector('[data-mc-unit-price]');
    const selectionLabel = form.querySelector('[data-mc-selection-label]');
    const addButton = form.querySelector('[data-mc-add-to-cart]');
    const addLabel = form.querySelector('[data-mc-add-label]');
    const stickyOffer = root.querySelector('[data-mc-sticky-offer]');
    const stickyPrice = root.querySelector('[data-mc-sticky-price]');
    const ctaText = addLabel?.textContent.trim() || 'COMPRAR AGORA';
    const soldOutText = root.dataset.soldOutLabel || 'ESGOTADO';

    const formatMoney = (cents) => {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(
          cents,
          root.dataset.moneyFormat
        );
      }

      return new Intl.NumberFormat(
        document.documentElement.lang || 'pt-BR',
        {
          style: 'currency',
          currency: root.dataset.currency || 'BRL'
        }
      ).format(cents / 100);
    };

    const updateCommercialDisplay = () => {
      const selectedOffer =
        offers.find((offer) =>
          offer.classList.contains('is-selected')
        ) || offers[0];

      const quantity = Number(
        selectedOffer?.dataset.quantity || 1
      );

      const price = Number(
        selectedOffer?.dataset.price || 0
      );

      const compareAt = Number(
        selectedOffer?.dataset.compareAt || 0
      );

      const available =
        selectedOffer?.dataset.available === 'true' &&
        Boolean(selectedOffer?.dataset.variantId);

      const hasSaving = compareAt > price;
      const unitWord =
        quantity === 1 ? 'Selador' : 'Seladores';

      variantInput.value =
        selectedOffer?.dataset.variantId || '';

      quantityInput.value = 1;

      priceElement.textContent =
        formatMoney(price);

      unitElement.textContent =
        `${formatMoney(Math.round(price / quantity))} por unidade`;

      compareElement.hidden = !hasSaving;
      savingsElement.hidden = !hasSaving;

      if (hasSaving) {
        compareElement.textContent =
          formatMoney(compareAt);

        savingsElement.textContent =
          `Economize ${formatMoney(compareAt - price)}`;
      }

      selectionLabel.textContent =
        `${selectedOffer.dataset.offerName} selecionada`;

      stickyOffer.textContent =
        `${selectedOffer.dataset.offerName} · ${quantity} ${unitWord}`;

      stickyPrice.textContent =
        formatMoney(price);

      addButton.disabled = !available;

      addLabel.textContent =
        available ? ctaText : soldOutText;
    };

    offers.forEach((offer) => {
      offer.addEventListener('click', () => {
        offers.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-checked', 'false');
        });

        offer.classList.add('is-selected');
        offer.setAttribute('aria-checked', 'true');

        updateCommercialDisplay();
      });
    });

    root
      .querySelectorAll('[data-mc-gallery-thumb]')
      .forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const stageImage = root.querySelector(
            '[data-mc-gallery-stage] img'
          );

          if (!stageImage) return;

          root
            .querySelectorAll('[data-mc-gallery-thumb]')
            .forEach((item) =>
              item.classList.remove('is-active')
            );

          thumb.classList.add('is-active');
          stageImage.src = thumb.dataset.src;
          stageImage.srcset = '';
          stageImage.alt = thumb.dataset.alt || '';
        });
      });

    updateCommercialDisplay();
  });
})();
/* Controle expansível das avaliações no celular */
(() => {
  const reviewSections = document.querySelectorAll(
    '[data-mc-reviews-collapsible]'
  );

  reviewSections.forEach((reviews) => {
    const container = reviews.parentElement;

    const toggle = container.querySelector(
      '[data-mc-reviews-toggle]'
    );

    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const expanded = reviews.classList.toggle('is-expanded');

      toggle.setAttribute(
        'aria-expanded',
        String(expanded)
      );

      toggle.textContent = expanded
        ? toggle.dataset.closeLabel
        : toggle.dataset.openLabel;

      if (!expanded) {
        reviews.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
})();